import React, { useState } from 'react';
import { signIn, signUp, confirmSignUp } from '../utils/auth';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [mode, setMode] = useState('login'); // login | newpass
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [newPass, setNewPass] = useState('');

  const handle = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (mode === 'newpass') {
        const session = await signIn(email, password, newPass);
        onLogin(session);
      } else {
        const session = await signIn(email, password);
        onLogin(session);
      }
    } catch (err) {
      if (err.code === 'NewPasswordRequired') {
        setMode('newpass');
      } else {
        setError(err.message || 'Error');
      }
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 400, margin: '80px auto', padding: 24, border: '1px solid #ddd', borderRadius: 8 }}>
      <h2>AWS News Curator</h2>
      <form onSubmit={handle}>
        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
          style={{ width: '100%', padding: 8, marginBottom: 8, boxSizing: 'border-box' }} required />
        {mode !== 'newpass' && (
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
            style={{ width: '100%', padding: 8, marginBottom: 8, boxSizing: 'border-box' }} required />
        )}
        {mode === 'newpass' && (
          <>
            <input type="password" placeholder="Current temporary password" value={password} onChange={(e) => setPassword(e.target.value)}
              style={{ width: '100%', padding: 8, marginBottom: 8, boxSizing: 'border-box' }} required disabled />
            <input type="password" placeholder="Set your new password" value={newPass} onChange={(e) => setNewPass(e.target.value)}
              style={{ width: '100%', padding: 8, marginBottom: 8, boxSizing: 'border-box' }} required />
          </>
        )}
        {error && <p style={{ color: 'red', fontSize: 14 }}>{error}</p>}
        <button type="submit" disabled={loading}
          style={{ width: '100%', padding: 10, background: '#232f3e', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
          {loading ? '...' : mode === 'newpass' ? 'Set Password' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}
